'use client';

import type { ComponentProps } from 'react';

import { Textarea } from '../ui/textarea';
import { useFieldControl } from './field';

export type TextAreaProps = ComponentProps<'textarea'>;

/**
 * Multi-line text entry (Figma: Components ↳ Inputs ↳ Text Area): 120px by
 * default, grows with content to 320px, then scrolls. Pair with Field for the
 * label and a character counter.
 */
export function TextArea(props: TextAreaProps) {
  return <Textarea {...useFieldControl(props)} />;
}
